<template>
  <div class="iphone" :class="{ 'is-active': active }">
    <!-- Side hardware buttons (CSS-only) -->
    <div class="btn-vol-up"></div>
    <div class="btn-vol-dn"></div>
    <div class="btn-power"></div>

    <!-- Screen area -->
    <div class="iphone-screen-wrap">
      <div class="iphone-screen" :class="`screen-${type}`">
        <!-- Dynamic Island -->
        <div class="dynamic-island"></div>

        <!-- ─────────── TASTE ─────────── -->
        <template v-if="type === 'taste'">
          <!-- Phase 1 (0–7s): Paste your ChatGPT response -->
          <div class="taste-phase taste-p1">
            <div class="t-header">
              <div class="t-brand">
                TILLY <span class="t-brand-thin">DECODED</span>
              </div>
              <div class="t-sub">Paste your ChatGPT response</div>
            </div>
            <!-- Provider row — ChatGPT selected -->
            <div class="t-providers">
              <div class="t-prov t-prov-active">
                <div class="t-prov-logo">
                  <img
                    src="@/assets/provider-chatgpt.png"
                    alt="ChatGPT"
                    class="t-prov-img"
                  />
                </div>
                <span class="t-prov-name">ChatGPT</span>
              </div>
              <div class="t-prov">
                <div class="t-prov-logo">
                  <img
                    src="@/assets/provider-claude.png"
                    alt="Claude"
                    class="t-prov-img"
                  />
                </div>
                <span class="t-prov-name">Claude</span>
              </div>
              <div class="t-prov">
                <div class="t-prov-logo">
                  <img
                    src="@/assets/provider-gemini.png"
                    alt="Gemini"
                    class="t-prov-img"
                  />
                </div>
                <span class="t-prov-name">Gemini</span>
              </div>
            </div>
            <!-- Paste box with real-looking example text -->
            <div class="t-paste-box">
              <div class="t-paste-cursor"></div>
              <div class="t-paste-text">
                <span class="t-pt-line"
                  >I live for under-the-radar spots my</span
                >
                <span class="t-pt-line"
                  >friends haven't heard of — boutique</span
                >
                <span class="t-pt-line"
                  >stays, quiet cafes, cozy pasta places.</span
                >
                <span class="t-pt-line"
                  >Vegetarian. Indian roots, SF-based.</span
                >
                <span class="t-pt-line t-pt-fade"
                  >I'd rather wander a neighborhood</span
                >
                <span class="t-pt-line t-pt-fade"
                  >than hit a tourist list...</span
                >
              </div>
            </div>
            <div class="t-decode-btn">
              <span class="t-decode-spinner"></span>
              Decoding your taste…
            </div>
          </div>

          <!-- Phase 2 (7–16s): TILLY DECODED result (matches real app layout) -->
          <div class="taste-phase taste-p2">
            <!-- Eyebrow -->
            <div class="t-decoded-eyebrow">TILLY DECODED</div>
            <!-- Title + subtitle on top, portrait photo below -->
            <div class="t-decoded-top">
              <div class="t-decoded-title">
                <div class="t-type-name">The Hidden-Gem Curator</div>
                <div class="t-type-sub">spot collector</div>
              </div>
              <div class="t-decoded-photo">
                <img
                  src="@/assets/images/taste-character.png"
                  alt="Taste character"
                  class="t-decoded-photo-img"
                  @error="$event.target.style.display = 'none'"
                />
              </div>
            </div>
            <!-- Description -->
            <p class="t-type-desc">
              You collect places the way other people collect screenshots:
              stylish, under-the-radar, and worth texting the group chat about.
            </p>
            <!-- Pill chips (2-col grid) -->
            <div class="t-traits">
              <div class="t-trait tr1"><span>🇮🇳</span> Indian roots</div>
              <div class="t-trait tr2"><span>🌉</span> SF based</div>
              <div class="t-trait tr3"><span>🥐</span> Pastry person</div>
              <div class="t-trait tr4"><span>🍝</span> Cozy pasta energy</div>
              <div class="t-trait tr5"><span>🫒</span> Mediterranean mode</div>
              <div class="t-trait tr6"><span>🥬</span> Vegetarian always</div>
              <div class="t-trait tr7"><span>🕵️</span> Hidden gem hunter</div>
              <div class="t-trait tr8"><span>🏨</span> Boutique stay snob</div>
              <div class="t-trait tr9">
                <span>🗺️</span> Culture-first traveler
              </div>
              <div class="t-trait tr10"><span>📸</span> Camera eats first</div>
            </div>
            <!-- Bottom: taste profile text block -->
            <div class="t-profile-block">
              <div class="t-profile-label">YOUR TILLY ALWAYS PICKS</div>
              <div class="t-profile-line">
                · Tiny cafe with a pastry case worth the detour
              </div>
              <div class="t-profile-line">
                · Boutique stay over any chain hotel
              </div>
              <div class="t-profile-line">
                · Culture-first, crowd-last itineraries
              </div>
            </div>
          </div>
        </template>

        <!-- ─────────── BOOKING ─────────── -->
        <template v-else-if="type === 'booking'">
          <div class="bk-header">
            <!-- Left: mascot avatar + name inline -->
            <div class="bk-ident">
              <div class="bk-mascot-av">
                <img
                  src="@/assets/images/tilly-mascot.png"
                  alt="Tilly"
                  style="width: 100%; height: 100%; object-fit: cover"
                />
              </div>
              <span class="bk-title">Tilly</span>
            </div>
            <!-- Right: bookings count pill -->
            <div class="bk-bookings-btn">🗓 Bookings</div>
          </div>
          <div class="bk-thread">
            <div class="bk-bubble bk-user bk-s1">
              book Pink Onion for 3 people for Friday
            </div>

            <div class="bk-plan bk-s2">
              <div class="bk-plan-head">Here's the plan 🍽️</div>
              <div class="bk-plan-row">
                <span>📍</span>Pink Onion, SF · Mission
              </div>
              <div class="bk-plan-row">
                <span>📅</span>Fri, Apr 25 · 7:30 PM
              </div>
              <div class="bk-plan-row">
                <span>👥</span>3 guests · under Tavishi
              </div>
              <div class="bk-plan-q">Lock it in?</div>
              <div class="bk-pills">
                <span class="bk-pill bk-pill-yes bk-tap">✓ Let's go!</span>
                <span class="bk-pill">✎ Tweak</span>
              </div>
            </div>

            <div class="bk-bubble bk-user bk-s3">Let's go!</div>

            <div class="bk-receipt bk-s4">
              <div class="bk-badge bk-inprog">
                <span class="bk-badge-dot"></span> In progress
              </div>
              <div class="bk-badge bk-conf">✓ Confirmed</div>
              <div class="bk-rest-name">Pink Onion</div>
              <div class="bk-rest-addr">San Francisco · Mission</div>
              <div class="bk-stepper">
                <div class="bk-step bk-st1">
                  <div class="bk-sdot"></div>
                  <span>Queued</span>
                </div>
                <div class="bk-sline bk-sl1"></div>
                <div class="bk-step bk-st2">
                  <div class="bk-sdot"></div>
                  <span>Finding</span>
                </div>
                <div class="bk-sline bk-sl2"></div>
                <div class="bk-step bk-st3">
                  <div class="bk-sdot"></div>
                  <span>Booking</span>
                </div>
                <div class="bk-sline bk-sl3"></div>
                <div class="bk-step bk-st4">
                  <div class="bk-sdot"></div>
                  <span>Booked ✓</span>
                </div>
              </div>
              <div class="bk-share">Share the booking ✉️</div>
            </div>
          </div>
        </template>

        <!-- ─────────── SNAP ─────────── -->
        <template v-else-if="type === 'snap'">
          <!-- Phase 1: User is viewing an Instagram post, takes a screenshot -->
          <div class="sn-ph sn-ph1">
            <div class="sn-insta"></div>
            <!-- Tap ripple indicating the user pressed volume-up + power -->
            <div class="sn-tap-ripple"></div>
            <!-- Screenshot flash overlay -->
            <div class="sn-flash"></div>
            <!-- Label pill that briefly confirms the action -->
            <div class="sn-shot-label">
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path
                  d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
                />
                <circle cx="12" cy="13" r="4" />
              </svg>
              <span>Screenshotted</span>
            </div>
            <!-- iOS-style thumbnail slides in at bottom-left -->
            <div class="sn-shot-thumb">
              <div class="sn-shot-thumb-img"></div>
            </div>
          </div>

          <!-- Phase 2 (4–7.5s): Upload Images — Finding places -->
          <div class="sn-ph sn-ph2">
            <div class="sn-ui-hdr">
              <span class="sn-ui-back">←</span>
              <span class="sn-ui-title">Upload Images</span>
            </div>
            <div class="sn-thumb-row">
              <!-- Square photo thumbnail — no IG bar, just the photo -->
              <div class="sn-thumb-sq">
                <div class="sn-thumb-sq-photo"></div>
                <div class="sn-thumb-x">✕</div>
              </div>
              <div class="sn-thumb-add">+</div>
            </div>
            <div class="sn-status-card">
              <div class="sn-pin">
                <img src="@/assets/images/tilly-mascot.png" alt="" />
              </div>
              <div class="sn-sc-body">
                <div class="sn-sc-title">Finding places…</div>
                <div class="sn-sc-sub">Give me a second, scanning this!</div>
              </div>
              <div class="sn-sc-spin"></div>
            </div>
          </div>

          <!-- Phase 3 (7.5–12s): Upload Images — Found 1 place -->
          <div class="sn-ph sn-ph3">
            <div class="sn-ui-hdr">
              <span class="sn-ui-back">←</span>
              <span class="sn-ui-title">Upload Images</span>
            </div>
            <div class="sn-thumb-row">
              <!-- Square photo thumbnail — no IG bar -->
              <div class="sn-thumb-sq">
                <div class="sn-thumb-sq-photo"></div>
                <div class="sn-thumb-x">✕</div>
              </div>
              <div class="sn-thumb-add">+</div>
            </div>
            <div class="sn-status-card sn-sc-found">
              <div class="sn-pin">
                <img src="@/assets/images/tilly-mascot.png" alt="" />
              </div>
              <div class="sn-sc-body">
                <div class="sn-sc-title">Found 1 place</div>
                <div class="sn-sc-sub">Tap to deselect any you don't want</div>
              </div>
            </div>
            <!-- Place result card -->
            <div class="sn-place-result">
              <div class="sn-pr-check">✓</div>
              <div class="sn-pr-text">
                <div class="sn-pr-name">San Vicente Bungalows</div>
                <div class="sn-pr-addr">
                  845 N San Vicente Blvd, West Hollywood, CA
                </div>
              </div>
            </div>
            <div class="sn-action-pair">
              <div class="sn-want">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
                </svg>
                <span>Want to go</span>
              </div>
              <div class="sn-been">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="9 12 11 14 15 10" />
                </svg>
                <span>Been</span>
              </div>
            </div>
            <div class="sn-save-big">♥ Save 1 Place</div>
          </div>
        </template>

        <!-- ─────────── HAPPENING ─────────── -->
        <template v-else-if="type === 'happening'">
          <!-- Header -->
          <div class="hap-head">
            <div class="hap-title">What's Happening</div>
            <div class="hap-loc-row">
              <span class="hap-loc-chip">📍 New York</span>
              <span class="hap-loc-chip">📅 This week</span>
            </div>
          </div>
          <!-- Day filter tabs -->
          <div class="hap-day-tabs">
            <span class="hap-day hap-day-on">All</span>
            <span class="hap-day">Today</span>
            <span class="hap-day">Tomorrow</span>
            <span class="hap-day">Sat</span>
            <span class="hap-day">Sun</span>
          </div>
          <!-- Category tabs — mirror the live app's category row -->
          <div class="hap-cat-tabs">
            <span class="hap-ct">🗓 Events</span>
            <span class="hap-ct">🎵 Music</span>
            <span class="hap-ct">🎓 Classes</span>
            <span class="hap-ct">🍽 Food</span>
            <span class="hap-ct">🌿 Outdoor</span>
          </div>
          <!-- Inventory count line, straight from the live app -->
          <div class="hap-count">9 things this week</div>
          <!-- Event card 1 -->
          <div class="hap-ev hap-ev1 hap-acc-green">
            <div class="hap-ev-tag hap-tag-green">🌿 Outdoor</div>
            <div class="hap-ev-title">Taiwan: A World of Orchids 2026</div>
            <div class="hap-ev-meta">
              <span class="hap-ev-date"
                >📅 {{ hapWeekend.sat }} · 10:00 AM</span
              >
              <span class="hap-ev-badge">$10</span>
            </div>
            <div class="hap-ev-reason">
              ✨ The Queens Botanical Garden turns into an orchid paradise for
              just one weekend
            </div>
            <div class="hap-ev-foot">
              <span class="hap-ev-url">queensbotanical.org</span>
              <div class="hap-ev-acts">
                <span class="hap-btn-plan">✨ Plan around it</span>
                <span class="hap-btn-share">
                  <svg
                    width="8"
                    height="8"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                    <polyline points="16 6 12 2 8 6" />
                    <line x1="12" y1="2" x2="12" y2="15" />
                  </svg>
                </span>
                <span class="hap-btn-save hap-btn-tap">
                  <svg
                    class="hap-bk hap-bk-line"
                    width="8"
                    height="8"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
                    />
                  </svg>
                  <svg
                    class="hap-bk hap-bk-fill"
                    width="8"
                    height="8"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <!-- Event card 2 -->
          <div class="hap-ev hap-ev2 hap-acc-violet">
            <div class="hap-ev-tag hap-tag-violet">🎓 Class</div>
            <div class="hap-ev-title">
              Mozzarella Making at Murray's Cheese Shop
            </div>
            <div class="hap-ev-meta">
              <span class="hap-ev-date">📅 {{ hapWeekend.sun }} · 2:00 PM</span>
              <span class="hap-ev-badge">$75</span>
            </div>
            <div class="hap-ev-reason">
              ✨ Learn the art of curd at this classic Bleecker Street
              institution
            </div>
            <div class="hap-ev-foot">
              <span class="hap-ev-url">localwineevents.com</span>
              <div class="hap-ev-acts">
                <span class="hap-btn-plan">✨ Plan around it</span>
                <span class="hap-btn-share">
                  <svg
                    width="8"
                    height="8"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                    <polyline points="16 6 12 2 8 6" />
                    <line x1="12" y1="2" x2="12" y2="15" />
                  </svg>
                </span>
                <span class="hap-btn-save hap-btn-saved">
                  <svg
                    width="8"
                    height="8"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <!-- Event card 3 -->
          <div class="hap-ev hap-ev3 hap-acc-teal">
            <div class="hap-ev-tag hap-tag-teal">🛒 Market</div>
            <div class="hap-ev-title">We Love NYC Bazaar</div>
            <div class="hap-ev-meta">
              <span class="hap-ev-date"
                >📅 {{ hapWeekend.sun }} · 10:00 AM</span
              >
              <span class="hap-ev-badge">Free</span>
            </div>
            <div class="hap-ev-reason">
              ✨ The city's biggest weekly curated market featuring local makers
              and vintage finds
            </div>
            <div class="hap-ev-foot">
              <span class="hap-ev-url">donyc.com</span>
              <div class="hap-ev-acts">
                <span class="hap-btn-plan">✨ Plan around it</span>
                <span class="hap-btn-share">
                  <svg
                    width="8"
                    height="8"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                    <polyline points="16 6 12 2 8 6" />
                    <line x1="12" y1="2" x2="12" y2="15" />
                  </svg>
                </span>
                <span class="hap-btn-save">
                  <svg
                    width="8"
                    height="8"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </template>

        <!-- ─────────── RATE GAME ─────────── -->
        <template v-else-if="type === 'rategame'">
          <!-- Header -->
          <div class="rg-head">
            <div class="rg-title">Inspo</div>
            <div class="rg-meta">
              <span class="rg-streak"
                ><span class="rg-chip-emoji">🔥</span
                ><span class="rg-chip-num">7</span></span
              >
              <span class="rg-score"
                ><span class="rg-chip-emoji">🏆</span>
                <span class="rg-chip-num rg-paw-stack"
                  ><span class="rg-pawnum rg-pawnum-1">124</span
                  ><span class="rg-pawnum rg-pawnum-2">134</span
                  ><span class="rg-pawnum rg-pawnum-3">144</span
                  ><span class="rg-pawnum rg-pawnum-4">154</span></span
                ></span
              >
            </div>
          </div>
          <!-- Progress bar -->
          <div class="rg-progress">
            <div class="rg-progress-fill"></div>
          </div>

          <!-- Card stack -->
          <div class="rg-stack">
            <!-- Back card (3rd) -->
            <div class="rg-card rg-card-back">
              <div class="rg-card-photo rg-photo-3"></div>
              <div class="rg-card-info">
                <div class="rg-card-name">Fog Harbor</div>
                <div class="rg-card-sub">Seafood · Embarcadero</div>
              </div>
            </div>
            <!-- Middle card (2nd) -->
            <div class="rg-card rg-card-mid">
              <div class="rg-card-photo rg-photo-2"></div>
              <div class="rg-card-info">
                <div class="rg-card-name">Midnight Proof</div>
                <div class="rg-card-sub">Cocktails · Mission</div>
                <div class="rg-card-stars">
                  ★★★★<span class="rg-star-dim">★</span>
                </div>
              </div>
            </div>
            <!-- Top card (swipes) -->
            <div class="rg-card rg-card-top">
              <div class="rg-card-photo rg-photo-1"></div>
              <div class="rg-card-info">
                <div class="rg-card-name">Nob Hill Cafe</div>
                <div class="rg-card-sub">Italian · Nob Hill, SF</div>
                <div class="rg-card-stars">★★★★★</div>
              </div>
              <!-- Direction overlays (only one fades in per cycle phase) -->
              <div class="rg-ov rg-ov-like">
                <div class="rg-ov-badge rg-ov-like-badge">
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
                    />
                  </svg>
                </div>
                <div class="rg-ov-label">LIKE</div>
              </div>
              <div class="rg-ov rg-ov-nope">
                <div class="rg-ov-badge rg-ov-nope-badge">
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"
                    />
                  </svg>
                </div>
                <div class="rg-ov-label">NAH</div>
              </div>
              <div class="rg-ov rg-ov-love">
                <div class="rg-ov-badge rg-ov-love-badge">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                    />
                  </svg>
                </div>
                <div class="rg-ov-label">LOVE</div>
              </div>
            </div>
          </div>

          <!-- Floating delta -->
          <div class="rg-delta">+5</div>

          <!-- Legend -->
          <div class="rg-legend">
            <span class="rg-leg"><span class="rg-leg-arrow">↑</span> LOVE</span>
            <span class="rg-leg"><span class="rg-leg-arrow">→</span> LIKE</span>
            <span class="rg-leg"><span class="rg-leg-arrow">↓</span> SKIP</span>
            <span class="rg-leg"><span class="rg-leg-arrow">←</span> NAH</span>
          </div>
        </template>
      </div>

      <!-- Home indicator -->
      <div class="home-bar"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeatureMockup',
  props: {
    type: {
      type: String,
      required: true,
      validator: (v) =>
        ['taste', 'booking', 'snap', 'happening', 'rategame'].includes(v),
    },
    /* When false, animations are disabled. Toggling false→true restarts
       every keyframe from 0 — so each scene begins at its first phase
       the moment the user scrolls to it. */
    active: { type: Boolean, default: true },
  },
  computed: {
    /* Rolling weekend dates for the happening mockup ("Sat, Aug 22" /
       "Sun, Aug 23"). Always the UPCOMING Saturday + Sunday, so the
       event cards never read as stale — once the weekend passes, the
       labels roll to next week automatically. */
    hapWeekend() {
      const now = new Date();
      const sat = new Date(now);
      sat.setDate(now.getDate() + ((6 - now.getDay() + 7) % 7));
      const sun = new Date(sat);
      sun.setDate(sat.getDate() + 1);
      const fmt = (d, dow) =>
        `${dow}, ${d.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
        })}`;
      return { sat: fmt(sat, 'Sat'), sun: fmt(sun, 'Sun') };
    },
  },
};
</script>

<style scoped>
/* ═══════════════════════════════════════
   REALISTIC iPHONE 15 FRAME
   ═══════════════════════════════════════ */
.iphone {
  position: relative;
  --iphone-home-indicator-reserve: 20px;
  width: 260px; /* fixed natural calibrated size — scaled via zoom on parent */
  aspect-ratio: 393 / 852; /* iPhone 15 exact ratio */
  border-radius: 50px;
  /* Titanium frame gradient */
  background: linear-gradient(
    145deg,
    #6b6b6d 0%,
    #4a4a4c 15%,
    #2c2c2e 40%,
    #1c1c1e 55%,
    #3a3a3c 75%,
    #4e4e50 90%,
    #5a5a5c 100%
  );
  padding: 3px 4px 6px;
  /* Drop-shadow stack for depth. The 0.5px outer ring and 1px inset
     lines were visible at mobile zoom (0.7) as jagged notches where
     the rounded corners meet the frame — removed because anything
     smaller than 1 device pixel triggers sub-pixel anti-aliasing
     along the curve. Kept the three blurred drop-shadows since
     they're large enough to render cleanly. */
  box-shadow: 0 50px 100px rgba(0, 0, 0, 0.45), 0 25px 50px rgba(0, 0, 0, 0.3),
    0 8px 20px rgba(0, 0, 0, 0.2);
  /* Force own compositor layer so the border-radius clip stays crisp
     at fractional pixel scales. */
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

/* Volume buttons (left side) */
.btn-vol-up,
.btn-vol-dn {
  position: absolute;
  left: -2.5px;
  width: 2.5px;
  border-radius: 2px 0 0 2px;
  background: linear-gradient(90deg, #3a3a3c, #5a5a5c);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
}
.btn-vol-up {
  top: 22%;
  height: 7%;
}
.btn-vol-dn {
  top: 31%;
  height: 7%;
}

/* Power/side button (right) */
.btn-power {
  position: absolute;
  right: -2.5px;
  top: 26%;
  width: 2.5px;
  height: 10%;
  border-radius: 0 2px 2px 0;
  background: linear-gradient(90deg, #5a5a5c, #3a3a3c);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

/* Screen bezel + screen area */
.iphone-screen-wrap {
  width: 100%;
  height: 100%;
  border-radius: 45px 45px 42px 42px;
  background: #000;
  overflow: hidden;
  overflow: clip;
  clip-path: inset(0 round 45px 45px 42px 42px);
  -webkit-clip-path: inset(0 round 45px 45px 42px 42px);
  position: relative;
  display: flex;
  flex-direction: column;
  /* Own compositor layer keeps the inner rounded clip crisp under
     zoom; pairs with the parent `.iphone` layer above. Also
     isolates the stacking context so border-radius clipping is
     applied before any parent transforms. */
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  isolation: isolate;
  contain: paint;
}

.iphone-screen {
  flex: 1;
  position: relative;
  overflow: hidden;
  clip-path: inset(0 round 45px 45px 42px 42px);
  -webkit-clip-path: inset(0 round 45px 45px 42px 42px);
  font-family: 'AirbnbCereal_W_Bk', -apple-system, 'SF Pro Text', sans-serif;
  font-size: 11px;
  color: #1a1a1a;
  /* Padding: top clears Dynamic Island, bottom reserves space for the
     overlaid home indicator so content doesn't drift into the lower
     curve once the screen fills the full device height. */
  padding: 52px 14px calc(12px + var(--iphone-home-indicator-reserve));
  display: flex;
  flex-direction: column;
  gap: 7px;
}

/* Screen backgrounds per feature */
.screen-taste {
  background: #f2ede8;
}
.screen-booking {
  background: linear-gradient(180deg, #fff 0%, #fef5f3 100%);
}
.screen-snap {
  background: #07070d;
} /* dark base so dead zones don't flash white */
.screen-happening {
  background: linear-gradient(180deg, #fff 0%, #f5fdf9 100%);
}

/* Dynamic Island */
.dynamic-island {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 95px;
  height: 28px;
  background: #000;
  border-radius: 20px;
  z-index: 20;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.06);
}

/* Home indicator */
.home-bar {
  position: absolute;
  left: 50%;
  bottom: 8px;
  width: 100px;
  height: 4px;
  background: rgba(60, 60, 67, 0.45);
  border-radius: 999px;
  transform: translateX(-50%);
  z-index: 12;
  pointer-events: none;
}
.screen-snap + .home-bar {
  background: rgba(255, 255, 255, 0.34);
}

/* ═══════════════════════════════════════
   TASTE MOCKUP
   ═══════════════════════════════════════ */
.taste-phase {
  position: absolute;
  inset: 52px 0 calc(20px + var(--iphone-home-indicator-reserve));
  padding: 0 14px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  opacity: 0;
  pointer-events: none;
  overflow: hidden;
}

/* 8s loop — Phase 1 (paste/decoding) 0–2s · Phase 2 (result) 2–7.8s · reset 7.8–8s */
.taste-p1 {
  animation: tp1 8s linear infinite;
}
.taste-p2 {
  gap: 8px;
  animation: tp2 8s linear infinite;
}

@keyframes tp1 {
  0% {
    opacity: 0;
    transform: translateY(8px);
  }
  3% {
    opacity: 1;
    transform: translateY(0);
  }
  20% {
    opacity: 1;
  }
  24% {
    opacity: 0;
    transform: translateY(-5px);
  }
  100% {
    opacity: 0;
  }
}
@keyframes tp2 {
  0%,
  24% {
    opacity: 0;
    transform: translateY(8px);
  }
  28% {
    opacity: 1;
    transform: translateY(0);
  }
  97% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(-5px);
  }
}

/* ── Brand header (both phases) ── */
.t-header,
.t-res-header {
  text-align: center;
  padding-top: 4px;
  flex-shrink: 0;
}
.t-brand {
  font-family: 'AirbnbCereal_W_Bd', sans-serif;
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.06em;
  color: #1a1a1a;
}
.t-brand-thin {
  font-size: 8px;
  font-weight: 500;
  letter-spacing: 0.18em;
  color: #8e8e93;
}
.t-sub {
  font-size: 9px;
  color: #6b7280;
  font-weight: 500;
  margin-top: 2px;
}

/* ── Provider pills ── */
.t-providers {
  display: flex;
  gap: 5px;
  flex-shrink: 0;
}
.t-prov {
  flex: 1;
  background: #f5f5f7;
  border-radius: 10px;
  padding: 7px 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  border: 1.5px solid transparent;
}
.t-prov-active {
  background: rgba(88, 168, 225, 0.07);
  border-color: rgba(88, 168, 225, 0.55);
}
.t-prov-logo {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
}
.t-prov-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 6px;
}
.t-prov-name {
  font-size: 7.5px;
  font-weight: 600;
  color: #1a1a1a;
}

/* ── Paste box ── */
.t-paste-box {
  flex: 1;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  position: relative;
  overflow: hidden;
}
.t-paste-cursor {
  position: absolute;
  top: 9px;
  left: 10px;
  width: 1.5px;
  height: 11px;
  background: #58a8e1;
  border-radius: 1px;
  animation: t-blink 1s step-end infinite;
}
@keyframes t-blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
.t-paste-text {
  display: flex;
  flex-direction: column;
  gap: 3.5px;
  padding-left: 8px;
  font-size: 8px;
  color: #374151;
  line-height: 1.4;
}
.t-pt-line {
  display: block;
}
.t-pt-fade {
  color: #9ca3af;
}

/* ── Decode button ── */
.t-decode-btn {
  background: linear-gradient(135deg, #1a1a1a, #2d2d2d);
  color: white;
  border-radius: 10px;
  padding: 8px 10px;
  text-align: center;
  font-weight: 700;
  font-size: 9.5px;
  letter-spacing: 0.01em;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.t-decode-spinner {
  width: 11px;
  height: 11px;
  border: 1.5px solid rgba(255, 255, 255, 0.25);
  border-top-color: #fff;
  border-radius: 50%;
  animation: t-spin 0.38s linear infinite;
  flex-shrink: 0;
}
@keyframes t-spin {
  to {
    transform: rotate(360deg);
  }
}

/* ── Phase 2: Decoded result (matches real app) ── */
.t-decoded-eyebrow {
  font-size: 7.5px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #9ca3af;
  flex-shrink: 0;
}
.t-decoded-top {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  flex-shrink: 0;
}
.t-decoded-photo {
  width: 130px;
  height: 130px;
  border-radius: 22px;
  overflow: hidden;
  flex-shrink: 0;
  background: linear-gradient(145deg, #fff3d4 0%, #ffe0b2 60%, #ffd08a 100%);
}
.t-decoded-photo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.t-decoded-title {
  width: 100%;
  min-width: 0;
  text-align: left;
  padding-top: 1px;
}
.t-type-name {
  font-family: 'AirbnbCereal_W_Bd', sans-serif;
  font-size: 13px;
  font-weight: 900;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: #0f172a;
  margin-bottom: 3px;
  white-space: nowrap;
}
.t-type-sub {
  font-size: 8.5px;
  color: #6b7280;
  font-weight: 500;
}
.t-type-desc {
  font-size: 8px;
  color: #374151;
  line-height: 1.5;
  margin: 0;
  flex-shrink: 0;
}

/* ── Trait chips (pill style — matches real app) ── */
.t-traits {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
  width: 100%;
}
.t-trait {
  background: #f0ede8;
  border-radius: 999px;
  padding: 5px 8px;
  font-size: 8px;
  font-weight: 600;
  color: #1a1a1a;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 4px;
  opacity: 0;
  transform: translateY(4px);
  /* Allow wrap rather than clip — the longer labels ("Cozy pasta
     energy", "Culture-first traveler", "Boutique stay snob") were
     getting cut off at the right edge in the 2-col grid. Wrap
     keeps them legible; min-width: 0 lets the flex text shrink
     instead of forcing overflow. */
  white-space: normal;
  overflow: visible;
  line-height: 1.25;
  min-width: 0;
}
.t-trait > :not(span) {
  min-width: 0;
}
.t-trait span {
  flex-shrink: 0;
  font-size: 10px;
}
/* Staggered entrance tightly after phase 2's header fades in */
.tr1 {
  animation: t-trait-in 8s linear infinite 0.03s;
}
.tr2 {
  animation: t-trait-in 8s linear infinite 0.06s;
}
.tr3 {
  animation: t-trait-in 8s linear infinite 0.09s;
}
.tr4 {
  animation: t-trait-in 8s linear infinite 0.12s;
}
.tr5 {
  animation: t-trait-in 8s linear infinite 0.15s;
}
.tr6 {
  animation: t-trait-in 8s linear infinite 0.18s;
}
.tr7 {
  animation: t-trait-in 8s linear infinite 0.21s;
}
.tr8 {
  animation: t-trait-in 8s linear infinite 0.24s;
}
.tr9 {
  animation: t-trait-in 8s linear infinite 0.27s;
}
.tr10 {
  animation: t-trait-in 8s linear infinite 0.3s;
}
@keyframes t-trait-in {
  0%,
  30% {
    opacity: 0;
    transform: translateY(4px);
  }
  36%,
  95% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
  }
}

/* ── Bottom taste profile block ── */
.t-profile-block {
  border-top: 1px solid rgba(0, 0, 0, 0.07);
  padding-top: 7px;
  margin-top: 2px;
  flex-shrink: 0;
  opacity: 0;
  animation: t-profile-in 8s linear infinite;
}
@keyframes t-profile-in {
  0%,
  40% {
    opacity: 0;
    transform: translateY(5px);
  }
  46%,
  95% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
  }
}
.t-profile-label {
  font-size: 6.5px;
  font-weight: 700;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: #9ca3af;
  margin-bottom: 5px;
}
.t-profile-line {
  font-size: 8px;
  color: #374151;
  line-height: 1.6;
  padding-left: 2px;
}

/* ═══════════════════════════════════════
   BOOKING MOCKUP
   ═══════════════════════════════════════ */
.bk-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}
/* Left: avatar + name in a row */
.bk-ident {
  display: flex;
  align-items: center;
  gap: 7px;
}
.bk-mascot-av {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  background: #f2ede8;
  flex-shrink: 0;
}
.bk-title {
  font-family: 'AirbnbCereal_W_Bd', sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
}
/* Right: bookings pill */
.bk-bookings-btn {
  font-size: 8px;
  font-weight: 700;
  color: #58a8e1;
  background: rgba(88, 168, 225, 0.1);
  border: 1px solid rgba(88, 168, 225, 0.25);
  border-radius: 999px;
  padding: 4px 9px;
  white-space: nowrap;
  flex-shrink: 0;
}

.bk-thread {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow: hidden;
}

.bk-bubble {
  padding: 7px 10px;
  border-radius: 14px;
  font-size: 10px;
  line-height: 1.35;
  max-width: 82%;
  opacity: 0;
}
.bk-user {
  background: linear-gradient(135deg, #58a8e1, #3a8ec7);
  color: white;
  align-self: flex-end;
  border-bottom-right-radius: 4px;
  box-shadow: 0 3px 8px rgba(88, 168, 225, 0.3);
}

/* Booking sequence (14s loop) */
/* Each message's full lifecycle fits inside a single 11s loop — no delay, no cross-cycle bleed */
.bk-s1 {
  animation: bk-msg-1 9s linear infinite;
}
.bk-s2 {
  animation: bk-msg-2 9s linear infinite;
}
.bk-s3 {
  animation: bk-msg-3 9s linear infinite;
}
.bk-s4 {
  animation: bk-msg-4 9s linear infinite;
}
/* Per-message keyframes — each message enters at its designated moment, and all wipe together at 96-100% */
@keyframes bk-msg-1 {
  0%,
  2% {
    opacity: 0;
    transform: translateY(10px) scale(0.96);
  }
  4%,
  95% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  98%,
  100% {
    opacity: 0;
    transform: translateY(-4px) scale(0.98);
  }
}
@keyframes bk-msg-2 {
  0%,
  14% {
    opacity: 0;
    transform: translateY(10px) scale(0.96);
  }
  16%,
  95% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  98%,
  100% {
    opacity: 0;
    transform: translateY(-4px) scale(0.98);
  }
}
@keyframes bk-msg-3 {
  0%,
  30% {
    opacity: 0;
    transform: translateY(10px) scale(0.96);
  }
  32%,
  95% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  98%,
  100% {
    opacity: 0;
    transform: translateY(-4px) scale(0.98);
  }
}
@keyframes bk-msg-4 {
  0%,
  38% {
    opacity: 0;
    transform: translateY(10px) scale(0.96);
  }
  40%,
  95% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  98%,
  100% {
    opacity: 0;
    transform: translateY(-4px) scale(0.98);
  }
}

.bk-plan {
  align-self: flex-start;
  max-width: 90%;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 14px 14px 14px 4px;
  padding: 10px 11px;
  font-size: 9.5px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.07);
  display: flex;
  flex-direction: column;
  gap: 3px;
  opacity: 0;
}
.bk-plan-head {
  font-family: 'AirbnbCereal_W_Bd', sans-serif;
  font-size: 11px;
  font-weight: 700;
  margin-bottom: 2px;
}
.bk-plan-row {
  display: flex;
  gap: 5px;
  align-items: flex-start;
  font-size: 9px;
  color: #3a3a3a;
  line-height: 1.3;
}
.bk-plan-q {
  margin-top: 4px;
  font-weight: 600;
  font-size: 9.5px;
}
.bk-pills {
  display: flex;
  gap: 4px;
  margin-top: 4px;
}
.bk-pill {
  background: #f3f4f6;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 999px;
  padding: 4px 8px;
  font-size: 8.5px;
  font-weight: 600;
  color: #4b5563;
}
.bk-pill-yes {
  border-color: #58a8e1;
  color: #58a8e1;
  background: rgba(88, 168, 225, 0.08);
}
.bk-tap {
  animation: bk-tap 9s linear infinite;
}
@keyframes bk-tap {
  0%,
  26%,
  100% {
    transform: scale(1);
  }
  27% {
    transform: scale(0.9);
  }
  29% {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(88, 168, 225, 0.45);
  }
  31% {
    transform: scale(1);
  }
}

.bk-receipt {
  position: relative;
  background: #fff;
  border-radius: 14px;
  padding: 10px 11px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 3px;
  opacity: 0;
  font-size: 9px;
}
.bk-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 8.5px;
  font-weight: 700;
  border-radius: 999px;
  padding: 2px 7px;
  letter-spacing: 0.01em;
  align-self: flex-start;
}
.bk-inprog {
  background: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
}
.bk-badge-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #f59e0b;
  animation: bk-pulse 1s ease-in-out infinite;
}
.bk-conf {
  position: absolute;
  top: 10px;
  left: 11px;
  background: rgba(52, 199, 89, 0.12);
  color: #34c759;
  opacity: 0;
  animation: bk-conf-in 9s linear infinite;
}
@keyframes bk-conf-in {
  0%,
  80% {
    opacity: 0;
    transform: scale(0.7);
  }
  83%,
  96% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}
.bk-inprog {
  animation: bk-inprog-out 9s linear infinite;
}
@keyframes bk-inprog-out {
  0%,
  77% {
    opacity: 1;
  }
  80%,
  100% {
    opacity: 0;
  }
}

.bk-rest-name {
  font-family: 'AirbnbCereal_W_Bd', sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  margin-top: 14px;
}
.bk-rest-addr {
  font-size: 8.5px;
  color: #6b7280;
}

.bk-stepper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 7px 0 4px;
}
.bk-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  font-size: 7px;
  color: #9ca3af;
  font-weight: 600;
}
.bk-sdot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #e5e7eb;
}
.bk-sline {
  flex: 1;
  height: 1.5px;
  background: #e5e7eb;
  margin-top: -7px;
}
/* Stepper — matches ternapp: gray → amber (active) → blue (completed), final step GREEN */
.bk-st1 .bk-sdot {
  animation: bk-step-1 9s linear infinite;
}
.bk-st2 .bk-sdot {
  animation: bk-step-2 9s linear infinite;
}
.bk-st3 .bk-sdot {
  animation: bk-step-3 9s linear infinite;
}
.bk-st4 .bk-sdot {
  animation: bk-step-4 9s linear infinite;
}
.bk-st1 span {
  animation: bk-lbl-1 9s linear infinite;
}
.bk-st2 span {
  animation: bk-lbl-2 9s linear infinite;
}
.bk-st3 span {
  animation: bk-lbl-3 9s linear infinite;
}
.bk-st4 span {
  animation: bk-lbl-4 9s linear infinite;
}
.bk-sl1 {
  animation: bk-line-1 9s linear infinite;
}
.bk-sl2 {
  animation: bk-line-2 9s linear infinite;
}
.bk-sl3 {
  animation: bk-line-3 9s linear infinite;
}

/* Dots — each step flashes amber briefly then settles blue (green for final) */
@keyframes bk-step-1 {
  0%,
  48% {
    background: #e5e7eb;
    transform: scale(1);
    box-shadow: none;
  }
  50% {
    background: #f59e0b;
    transform: scale(1.35);
    box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.22);
  }
  55% {
    background: #58a8e1;
    transform: scale(1);
    box-shadow: none;
  }
  95% {
    background: #58a8e1;
  }
  100% {
    background: #e5e7eb;
  }
}
@keyframes bk-step-2 {
  0%,
  58% {
    background: #e5e7eb;
    transform: scale(1);
    box-shadow: none;
  }
  60% {
    background: #f59e0b;
    transform: scale(1.35);
    box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.22);
  }
  65% {
    background: #58a8e1;
    transform: scale(1);
    box-shadow: none;
  }
  95% {
    background: #58a8e1;
  }
  100% {
    background: #e5e7eb;
  }
}
@keyframes bk-step-3 {
  0%,
  68% {
    background: #e5e7eb;
    transform: scale(1);
    box-shadow: none;
  }
  70% {
    background: #f59e0b;
    transform: scale(1.35);
    box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.22);
  }
  75% {
    background: #58a8e1;
    transform: scale(1);
    box-shadow: none;
  }
  95% {
    background: #58a8e1;
  }
  100% {
    background: #e5e7eb;
  }
}
@keyframes bk-step-4 {
  0%,
  78% {
    background: #e5e7eb;
    transform: scale(1);
    box-shadow: none;
  }
  80% {
    background: #f59e0b;
    transform: scale(1.4);
    box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.24);
  }
  84% {
    background: #34c759;
    transform: scale(1);
    box-shadow: 0 0 0 3px rgba(52, 199, 89, 0.22);
  }
  95% {
    background: #34c759;
    box-shadow: none;
  }
  100% {
    background: #e5e7eb;
  }
}

/* Labels — match their dot's color */
@keyframes bk-lbl-1 {
  0%,
  48% {
    color: #9ca3af;
  }
  50% {
    color: #f59e0b;
  }
  55%,
  95% {
    color: #58a8e1;
    font-weight: 700;
  }
  100% {
    color: #9ca3af;
    font-weight: 600;
  }
}
@keyframes bk-lbl-2 {
  0%,
  58% {
    color: #9ca3af;
  }
  60% {
    color: #f59e0b;
  }
  65%,
  95% {
    color: #58a8e1;
    font-weight: 700;
  }
  100% {
    color: #9ca3af;
    font-weight: 600;
  }
}
@keyframes bk-lbl-3 {
  0%,
  68% {
    color: #9ca3af;
  }
  70% {
    color: #f59e0b;
  }
  75%,
  95% {
    color: #58a8e1;
    font-weight: 700;
  }
  100% {
    color: #9ca3af;
    font-weight: 600;
  }
}
@keyframes bk-lbl-4 {
  0%,
  78% {
    color: #9ca3af;
  }
  80% {
    color: #f59e0b;
  }
  84%,
  95% {
    color: #34c759;
    font-weight: 700;
  }
  100% {
    color: #9ca3af;
    font-weight: 600;
  }
}

/* Lines — fill blue as progression passes through each segment */
@keyframes bk-line-1 {
  0%,
  58% {
    background: #e5e7eb;
  }
  61%,
  95% {
    background: #58a8e1;
  }
  100% {
    background: #e5e7eb;
  }
}
@keyframes bk-line-2 {
  0%,
  68% {
    background: #e5e7eb;
  }
  71%,
  95% {
    background: #58a8e1;
  }
  100% {
    background: #e5e7eb;
  }
}
@keyframes bk-line-3 {
  0%,
  78% {
    background: #e5e7eb;
  }
  81% {
    background: #58a8e1;
  }
  84%,
  95% {
    background: #34c759;
  }
  100% {
    background: #e5e7eb;
  }
}
.bk-share {
  text-align: center;
  font-weight: 700;
  font-size: 9px;
  color: #34c759;
  background: rgba(52, 199, 89, 0.1);
  border: 1px solid rgba(52, 199, 89, 0.25);
  border-radius: 7px;
  padding: 5px 7px;
  opacity: 0;
  animation: bk-share-in 9s linear infinite;
}
@keyframes bk-share-in {
  0%,
  84% {
    opacity: 0;
    transform: translateY(4px) scale(0.94);
  }
  87% {
    opacity: 1;
    transform: translateY(0) scale(1.04);
  }
  92% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  97%,
  100% {
    opacity: 0;
    transform: translateY(-2px) scale(0.98);
  }
}

/* ═══════════════════════════════════════
   SNAP MOCKUP  (12s loop)
   Phase 1 = 0–4s · Phase 2 = 4–7.5s · Phase 3 = 7.5–12s
   ═══════════════════════════════════════ */

/* All phases fill the entire screen (behind dynamic island too) */
.sn-ph {
  position: absolute;
  inset: 0;
  opacity: 0;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  isolation: isolate; /* contain inner z-index so camera controls don't escape over upload phase */
}

/* Phase 1: dark camera — scene fills entire screen */
.sn-ph1 {
  padding-top: 52px; /* clear dynamic island area for controls */
  opacity: 1; /* shown at rest (before scene activates) so idle preview = Insta shot */
}

/* Phase 2 & 3: white UI screens — fill full screen, padding for dynamic island */
.sn-ph2 {
  padding: 60px 14px 10px;
  gap: 9px;
  background: #fff;
}
.sn-ph3 {
  padding: 60px 14px 10px;
  gap: 8px;
  background: #fff;
}

/* Animations only run on the active scene — guarantees the loop restarts
   from Phase 1 the moment the user scrolls here. Total cycle = 5s:
     0.0–1.0s  Phase 1 (screenshot snap, fast hook)
     1.0–2.5s  Phase 2 (Tilly scanning)
     2.5–5.0s  Phase 3 (place found — linger on the payoff) */
.is-active .sn-ph1 {
  animation: sn1 5s linear infinite;
}
.is-active .sn-ph2 {
  animation: sn2 5s linear infinite;
}
.is-active .sn-ph3 {
  animation: sn3 5s linear infinite;
}

/* Truly instant cuts (0.01% gap = sub-frame). */
@keyframes sn1 {
  0%,
  19.99% {
    opacity: 1;
  }
  20%,
  100% {
    opacity: 0;
  }
}
@keyframes sn2 {
  0%,
  19.99% {
    opacity: 0;
  }
  20%,
  35.99% {
    opacity: 1;
  }
  36%,
  100% {
    opacity: 0;
  }
}
@keyframes sn3 {
  0%,
  35.99% {
    opacity: 0;
  }
  36%,
  100% {
    opacity: 1;
  }
}

/* ── Phases 2 & 3: Upload Images UI header ── */
.sn-ui-hdr {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.sn-ui-back {
  font-size: 16px;
  color: #58a8e1;
  line-height: 1;
}
.sn-ui-title {
  font-family: 'AirbnbCereal_W_Bd', sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
  white-space: nowrap;
}

/* ── Thumbnail strip ── */
.sn-thumb-row {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
  align-items: flex-start;
}
/* Square photo thumbnail — matches real app */
.sn-thumb-sq {
  width: 60px;
  height: 60px;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.sn-thumb-sq-photo {
  width: 100%;
  height: 100%;
  background-image: url('~@/assets/images/snap-shay-bungalows.jpg');
  background-size: cover;
  background-position: center 35%;
}

/* Full-screen Instagram view (phase 1) — cropped screenshot, no duplicate iOS chrome */
.sn-insta {
  position: absolute;
  inset: 0;
  background-color: #000;
  background-image: url('~@/assets/images/snap-shay-bungalows.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

/* ── Phase 1: screenshot action — tap ripple, flash, label pill, iOS thumbnail ── */

/* Tap ripple on the right edge (where power button + volume-up are) */
.sn-tap-ripple {
  position: absolute;
  top: 28%;
  right: -6px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.85);
  opacity: 0;
  transform: scale(0.4);
  pointer-events: none;
  z-index: 4;
}
.is-active .sn-tap-ripple {
  animation: sn-tap-ripple 5s linear infinite;
}
@keyframes sn-tap-ripple {
  0%,
  6% {
    opacity: 0;
    transform: scale(0.4);
  }
  7% {
    opacity: 1;
    transform: scale(0.6);
  }
  9% {
    opacity: 0.5;
    transform: scale(1.4);
  }
  10%,
  100% {
    opacity: 0;
    transform: scale(1.6);
  }
}

/* White screenshot flash across the whole screen */
.sn-flash {
  position: absolute;
  inset: 0;
  background: white;
  opacity: 0;
  pointer-events: none;
  z-index: 5;
}
.is-active .sn-flash {
  animation: sn-flash 5s linear infinite;
}
@keyframes sn-flash {
  0%,
  7% {
    opacity: 0;
  }
  8% {
    opacity: 0.9;
  }
  10% {
    opacity: 0.3;
  }
  11%,
  100% {
    opacity: 0;
  }
}

/* "Screenshot" label pill — briefly centered, fades out */
.sn-shot-label {
  position: absolute;
  top: 42%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.92);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.82);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  color: white;
  font-family: 'AirbnbCereal_W_Bd', sans-serif;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
  opacity: 0;
  z-index: 6;
}
.is-active .sn-shot-label {
  animation: sn-shot-label 5s linear infinite;
}
@keyframes sn-shot-label {
  0%,
  8% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.85);
  }
  10% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.05);
  }
  12% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  19% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  20%,
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.92);
  }
}

/* iOS screenshot thumbnail — slides in from bottom-left corner */
.sn-shot-thumb {
  position: absolute;
  bottom: calc(16px + var(--iphone-home-indicator-reserve));
  left: 10px;
  width: 46px;
  height: 82px;
  border-radius: 6px;
  background: white;
  padding: 2px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);
  opacity: 0;
  transform: translateX(-120%) rotate(-4deg);
  z-index: 5;
}
.is-active .sn-shot-thumb {
  animation: sn-shot-thumb 5s linear infinite;
}
.sn-shot-thumb-img {
  width: 100%;
  height: 100%;
  background-image: url('~@/assets/images/snap-shay-bungalows.jpg');
  background-size: cover;
  background-position: center;
  border-radius: 4px;
}
/* Each cycle: 0–6% is a calm beat where you just see the Instagram post
   (no tap, flash, or label yet) so the image registers before the
   screenshot action kicks off. Then tap → flash → label → thumb slides
   in, sits through the pause, and slides out right at the Phase 2 cut. */
@keyframes sn-shot-thumb {
  0%,
  9% {
    opacity: 0;
    transform: translateX(-120%) rotate(-4deg);
  }
  11% {
    opacity: 1;
    transform: translateX(0) rotate(0deg);
  }
  18% {
    opacity: 1;
    transform: translateX(0) rotate(0deg);
  }
  20%,
  100% {
    opacity: 0;
    transform: translateX(-120%) rotate(-4deg);
  }
}
.sn-thumb-x {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #ef4444;
  color: white;
  font-size: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  z-index: 2;
}
.sn-thumb-add {
  width: 60px;
  height: 60px;
  border-radius: 10px;
  border: 1.5px dashed #d1d5db;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #9ca3af;
  flex-shrink: 0;
}

/* ── Amber status card ── */
.sn-status-card {
  display: flex;
  align-items: center;
  gap: 9px;
  background: rgba(253, 173, 0, 0.1);
  border-radius: 12px;
  padding: 10px 12px;
  border: 1px solid rgba(253, 173, 0, 0.25);
  flex-shrink: 0;
}
.sn-pin {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sn-pin img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.sn-sc-body {
  flex: 1;
  min-width: 0;
}
.sn-sc-title {
  font-family: 'AirbnbCereal_W_Bd', sans-serif;
  font-size: 10.5px;
  font-weight: 700;
  color: #0f172a;
}
.sn-sc-sub {
  font-size: 8px;
  color: #6b7280;
  margin-top: 1px;
}
.sn-sc-spin {
  width: 12px;
  height: 12px;
  border: 1.5px solid rgba(253, 173, 0, 0.3);
  border-top-color: #fdad00;
  border-radius: 50%;
  animation: sn-spin 0.8s linear infinite;
  flex-shrink: 0;
}
@keyframes sn-spin {
  to {
    transform: rotate(360deg);
  }
}

/* ── Phase 3: Found 1 place — result card ── */
.sn-place-result {
  display: flex;
  align-items: center;
  gap: 9px;
  background: white;
  border-radius: 12px;
  padding: 10px 12px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-left: 3px solid #58a8e1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
  opacity: 0;
}
.is-active .sn-place-result {
  animation: sn-place-in 5s linear infinite;
}
@keyframes sn-place-in {
  0%,
  36% {
    opacity: 0;
    transform: translateY(5px);
  }
  40%,
  97% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
  }
}
.sn-pr-check {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #58a8e1;
  color: white;
  font-size: 10px;
  font-weight: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.sn-pr-text {
  flex: 1;
  min-width: 0;
}
.sn-pr-name {
  font-family: 'AirbnbCereal_W_Bd', sans-serif;
  font-size: 10.5px;
  font-weight: 700;
  color: #0f172a;
}
.sn-pr-addr {
  font-size: 7.5px;
  color: #6b7280;
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Action pills (Want to go / Been) ── */
.sn-action-pair {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
  opacity: 0;
}
.is-active .sn-action-pair {
  animation: sn-place-in 5s linear infinite 0.08s;
}
.sn-want,
.sn-been {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border-radius: 999px;
  padding: 7px 10px;
  font-size: 9px;
  font-weight: 700;
  font-family: 'AirbnbCereal_W_Bd', sans-serif;
  letter-spacing: -0.01em;
}
.sn-want {
  background: rgba(253, 173, 0, 0.18);
  border: 1px solid rgba(253, 173, 0, 0.45);
  color: #b45309;
}
.sn-been {
  background: #f3f4f6;
  border: 1px solid rgba(0, 0, 0, 0.08);
  color: #6b7280;
}
.sn-want svg,
.sn-been svg {
  flex-shrink: 0;
}

/* ── Amber "Save 1 Place" CTA ── */
.sn-save-big {
  margin-top: auto;
  background: #fdad00;
  border-radius: 12px;
  padding: 11px;
  text-align: center;
  font-family: 'AirbnbCereal_W_Bd', sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: white;
  flex-shrink: 0;
  opacity: 0;
}
.is-active .sn-save-big {
  animation: sn-save-in 5s linear infinite;
}
@keyframes sn-save-in {
  0%,
  44% {
    opacity: 0;
    transform: translateY(6px);
  }
  48%,
  97% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
  }
}

/* ═══════════════════════════════════════
   HAPPENING MOCKUP  (real app style)
   ═══════════════════════════════════════ */
.hap-head {
  flex-shrink: 0;
}
.hap-title {
  font-family: 'AirbnbCereal_W_Bd', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
}
/* Location + date chips row */
.hap-loc-row {
  display: flex;
  gap: 5px;
}
.hap-loc-chip {
  font-size: 7.5px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 999px;
  background: #f0f1f3;
  color: #4b5563;
  border: 1px solid rgba(0, 0, 0, 0.07);
}

/* Day filter tabs */
.hap-day-tabs {
  display: flex;
  gap: 3px;
  flex-shrink: 0;
  overflow: hidden;
}
.hap-day {
  font-size: 7.5px;
  font-weight: 600;
  padding: 3px 7px;
  border-radius: 999px;
  background: #f0f1f3;
  color: #6b7280;
  white-space: nowrap;
  flex-shrink: 0;
}
.hap-day-on {
  background: #0f172a;
  color: white;
}

/* Category tabs */
.hap-cat-tabs {
  display: flex;
  gap: 3px;
  flex-shrink: 0;
  overflow: hidden;
}
.hap-ct {
  font-size: 7px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 999px;
  background: #f0f1f3;
  color: #6b7280;
  white-space: nowrap;
  flex-shrink: 0;
}
/* Inventory count line ("9 things this week") */
.hap-count {
  font-size: 7px;
  color: #9ca3af;
  flex-shrink: 0;
}

/* Event cards */
.hap-ev {
  background: white;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.07);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 6px 8px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex-shrink: 0;
  opacity: 0;
}
.hap-ev1 {
  animation: hap-ev-in-1 7.5s linear infinite;
}
.hap-ev2 {
  animation: hap-ev-in-2 7.5s linear infinite;
}
.hap-ev3 {
  animation: hap-ev-in-3 7.5s linear infinite;
}
@keyframes hap-ev-in-1 {
  0% {
    opacity: 0;
    transform: translateY(8px);
  }
  6% {
    opacity: 1;
    transform: translateY(0);
  }
  92% {
    opacity: 1;
    transform: translateY(0);
  }
  97%,
  100% {
    opacity: 0;
    transform: translateY(-4px);
  }
}
@keyframes hap-ev-in-2 {
  0%,
  4% {
    opacity: 0;
    transform: translateY(8px);
  }
  10% {
    opacity: 1;
    transform: translateY(0);
  }
  92% {
    opacity: 1;
    transform: translateY(0);
  }
  97%,
  100% {
    opacity: 0;
    transform: translateY(-4px);
  }
}
@keyframes hap-ev-in-3 {
  0%,
  8% {
    opacity: 0;
    transform: translateY(8px);
  }
  14% {
    opacity: 1;
    transform: translateY(0);
  }
  92% {
    opacity: 1;
    transform: translateY(0);
  }
  97%,
  100% {
    opacity: 0;
    transform: translateY(-4px);
  }
}

/* Colored left accent stripe, matching the live app's cards */
.hap-acc-green {
  border-left: 2.5px solid #10b981;
}
.hap-acc-violet {
  border-left: 2.5px solid #8b5cf6;
}
.hap-acc-teal {
  border-left: 2.5px solid #14b8a6;
}

/* Category tag pill */
.hap-ev-tag {
  font-size: 7px;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 2px 6px;
  border-radius: 999px;
  align-self: flex-start;
  text-transform: uppercase;
}
.hap-tag-green {
  background: rgba(16, 185, 129, 0.1);
  color: #065f46;
}
.hap-tag-violet {
  background: rgba(139, 92, 246, 0.12);
  color: #5b21b6;
}
.hap-tag-teal {
  background: rgba(20, 184, 166, 0.12);
  color: #0f766e;
}

/* Event title */
.hap-ev-title {
  font-family: 'AirbnbCereal_W_Bd', sans-serif;
  font-size: 9.5px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.25;
}

/* Date + badge row */
.hap-ev-meta {
  display: flex;
  align-items: center;
  gap: 5px;
}
/* Date as a light pill chip, price as a dark navy pill — live app style */
.hap-ev-date {
  font-size: 7px;
  font-weight: 600;
  color: #4b5563;
  background: #f0f1f3;
  padding: 2px 6px;
  border-radius: 999px;
  white-space: nowrap;
}
.hap-ev-badge {
  font-size: 7px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 999px;
  background: #0f172a;
  color: #ffffff;
}

/* AI reason text — amber sparkle + olive text, no chip (live app style) */
.hap-ev-reason {
  font-size: 7px;
  color: #7d6a3f;
  line-height: 1.35;
}

/* Footer: URL + actions */
.hap-ev-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1px;
}
.hap-ev-url {
  font-size: 7px;
  color: #9ca3af;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1;
}
.hap-ev-acts {
  display: flex;
  align-items: center;
  gap: 3px;
  flex-shrink: 0;
}
/* "Plan around it" pill — the hero action, same as the live app.
   Fixed 18px height to match the round Share/Save buttons beside it. */
.hap-btn-plan {
  display: inline-flex;
  align-items: center;
  height: 18px;
  box-sizing: border-box;
  font-size: 6.5px;
  font-weight: 700;
  color: #374151;
  background: #f3f4f6;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 999px;
  padding: 0 7px;
  white-space: nowrap;
  line-height: 1;
}
/* Share — icon-only round button */
.hap-btn-share {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  background: #f3f4f6;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 999px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
/* Save / bookmark round button */
.hap-btn-save {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  background: #f3f4f6;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 999px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
/* Saved state — amber fill */
.hap-btn-saved {
  color: #d97706;
  background: rgba(253, 173, 0, 0.12);
  border-color: rgba(253, 173, 0, 0.25);
}

/* Tap animation — loops with the card; state reset happens while card is invisible */
.hap-btn-tap {
  position: relative;
  animation: hap-btn-tap 7.5s linear infinite;
}
.hap-bk {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.hap-bk-line {
  animation: hap-bk-line 7.5s linear infinite;
}
.hap-bk-fill {
  opacity: 0;
  animation: hap-bk-fill 7.5s linear infinite;
}
@keyframes hap-btn-tap {
  /* Unsaved state while card fades in and sits briefly */
  0%,
  25% {
    transform: scale(1);
    color: #9ca3af;
    background: rgba(0, 0, 0, 0.04);
    border-color: rgba(0, 0, 0, 0.08);
  }
  /* Tap animation */
  28% {
    transform: scale(0.85);
    color: #d97706;
    background: rgba(253, 173, 0, 0.22);
  }
  31% {
    transform: scale(1.18);
  }
  /* Saved state held while card is visible */
  34%,
  96% {
    transform: scale(1);
    color: #d97706;
    background: rgba(253, 173, 0, 0.12);
    border-color: rgba(253, 173, 0, 0.25);
  }
  /* Reset to unsaved during card's invisible phase (97-100%) so user never sees it */
  97%,
  100% {
    transform: scale(1);
    color: #9ca3af;
    background: rgba(0, 0, 0, 0.04);
    border-color: rgba(0, 0, 0, 0.08);
  }
}
@keyframes hap-bk-line {
  0%,
  27% {
    opacity: 1;
  }
  29%,
  96% {
    opacity: 0;
  }
  97%,
  100% {
    opacity: 1;
  }
}
@keyframes hap-bk-fill {
  0%,
  27% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.4);
  }
  31% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.35);
  }
  34%,
  96% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  97%,
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.4);
  }
}

/* ═══════════════════════════════════════
   RATE GAME — swipe-card animation
   ═══════════════════════════════════════ */
.screen-rategame {
  background: linear-gradient(180deg, #faf7ff 0%, #f4eeff 100%);
}

.rg-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  padding: 36px 12px 8px;
}
.rg-title {
  font-family: 'AirbnbCereal_W_Bd', sans-serif;
  font-size: 13px;
  font-weight: 800;
  color: #1a1033;
  letter-spacing: -0.02em;
  white-space: nowrap;
  line-height: 1.15;
  min-width: 0;
}
.rg-meta {
  display: flex;
  gap: 5px;
  align-items: center;
  flex-shrink: 0;
}
.rg-streak,
.rg-score {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  background: #ffffff;
  padding: 4px 8px;
  border-radius: 999px;
  box-shadow: 0 2px 6px rgba(28, 12, 64, 0.1), 0 0 0 1px rgba(28, 12, 64, 0.04);
  line-height: 1;
}
.rg-chip-emoji {
  font-size: 10px;
  line-height: 1;
}
.rg-chip-num {
  font-family: 'AirbnbCereal_W_Bd', sans-serif;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1;
}
.rg-streak .rg-chip-num {
  color: #f59e0b;
}
.rg-score .rg-chip-num {
  color: #3b82f6;
}

/* Paw score ticks up +10 with each swipe, resets at loop end. Timed with rg-top-cycle. */
.rg-paw-stack {
  position: relative;
  display: inline-block;
  min-width: 22px;
  height: 1em;
  text-align: left;
}
.rg-pawnum {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  animation-duration: 5.6s;
  animation-iteration-count: infinite;
  animation-timing-function: steps(1, end);
}
.rg-pawnum-1 {
  animation-name: rg-pawn-1;
}
.rg-pawnum-2 {
  animation-name: rg-pawn-2;
}
.rg-pawnum-3 {
  animation-name: rg-pawn-3;
}
.rg-pawnum-4 {
  animation-name: rg-pawn-4;
}
@keyframes rg-pawn-1 {
  0%,
  37% {
    opacity: 1;
  }
  38%,
  100% {
    opacity: 0;
  }
}
@keyframes rg-pawn-2 {
  0%,
  37% {
    opacity: 0;
  }
  38%,
  69% {
    opacity: 1;
  }
  70%,
  100% {
    opacity: 0;
  }
}
@keyframes rg-pawn-3 {
  0%,
  69% {
    opacity: 0;
  }
  70%,
  96% {
    opacity: 1;
  }
  97%,
  100% {
    opacity: 0;
  }
}
@keyframes rg-pawn-4 {
  0%,
  96% {
    opacity: 0;
  }
  97%,
  99% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.rg-progress {
  margin: 0 14px 12px;
  height: 3px;
  background: rgba(124, 58, 237, 0.12);
  border-radius: 999px;
  overflow: hidden;
}
.rg-progress-fill {
  width: 30%;
  height: 100%;
  background: linear-gradient(90deg, #7c3aed 0%, #a78bfa 100%);
  border-radius: 999px;
  animation: rg-progress-cycle 5.6s infinite cubic-bezier(0.22, 0.61, 0.36, 1);
}
/* Ticks up as each card is rated, then decreases as the stack loops.
   Swipe timings mirror rg-top-cycle: LIKE at 34%, NAH at 66%, LOVE at 96%. */
@keyframes rg-progress-cycle {
  0%,
  33% {
    width: 30%;
  }
  38% {
    width: 52%;
  }
  65% {
    width: 52%;
  }
  70% {
    width: 70%;
  }
  94% {
    width: 70%;
  }
  97% {
    width: 92%;
  }
  100% {
    width: 30%;
  }
}

/* Card stack ------------------------------------------------ */
.rg-stack {
  position: relative;
  margin: 0 auto;
  width: 200px;
  height: 290px;
}
.rg-card {
  position: absolute;
  inset: 0;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 18px 34px rgba(28, 12, 64, 0.22),
    0 6px 14px rgba(28, 12, 64, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transform-origin: center top;
}
.rg-card-back {
  transform: translateY(18px) scale(0.88);
  z-index: 1;
  animation: rg-promote-back 5.6s infinite ease-out;
}
.rg-card-mid {
  transform: translateY(10px) scale(0.94);
  z-index: 2;
  animation: rg-promote-mid 5.6s infinite ease-out;
}
.rg-card-top {
  z-index: 3;
  animation: rg-top-cycle 5.6s infinite cubic-bezier(0.22, 0.61, 0.36, 1);
  transform-origin: bottom center;
}

@keyframes rg-top-cycle {
  0%,
  12% {
    transform: translate(0, 0) rotate(0deg);
    opacity: 1;
  }
  22% {
    transform: translate(20px, -4px) rotate(5deg);
    opacity: 1;
  }
  34% {
    transform: translate(180px, -10px) rotate(18deg);
    opacity: 0;
  }
  /* Snap the new top card back to center fully opaque — fading it in
     against the offset mid/back cards underneath caused their text to
     bleed through and overlap with the top card's text. */
  34.01% {
    transform: translate(0, 0) rotate(0deg);
    opacity: 1;
  }
  44% {
    transform: translate(0, 0) rotate(0deg);
    opacity: 1;
  }
  54% {
    transform: translate(-18px, -6px) rotate(-4deg);
    opacity: 1;
  }
  66% {
    transform: translate(-180px, -14px) rotate(-18deg);
    opacity: 0;
  }
  66.01% {
    transform: translate(0, 0) rotate(0deg);
    opacity: 1;
  }
  76% {
    transform: translate(0, 0) rotate(0deg);
    opacity: 1;
  }
  86% {
    transform: translate(0, -30px) rotate(0deg);
    opacity: 1;
  }
  96% {
    transform: translate(0, -260px) rotate(0deg);
    opacity: 0;
  }
  96.01% {
    transform: translate(0, 0) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translate(0, 0) rotate(0deg);
    opacity: 1;
  }
}

/* Mid card promotes subtly when top exits */
@keyframes rg-promote-mid {
  0%,
  30% {
    transform: translateY(10px) scale(0.94);
  }
  34% {
    transform: translateY(4px) scale(0.97);
  }
  44% {
    transform: translateY(10px) scale(0.94);
  }
  62% {
    transform: translateY(10px) scale(0.94);
  }
  66% {
    transform: translateY(4px) scale(0.97);
  }
  76% {
    transform: translateY(10px) scale(0.94);
  }
  92% {
    transform: translateY(10px) scale(0.94);
  }
  96% {
    transform: translateY(4px) scale(0.97);
  }
  100% {
    transform: translateY(10px) scale(0.94);
  }
}
@keyframes rg-promote-back {
  0%,
  30% {
    transform: translateY(18px) scale(0.88);
  }
  34% {
    transform: translateY(14px) scale(0.91);
  }
  44% {
    transform: translateY(18px) scale(0.88);
  }
  62% {
    transform: translateY(18px) scale(0.88);
  }
  66% {
    transform: translateY(14px) scale(0.91);
  }
  76% {
    transform: translateY(18px) scale(0.88);
  }
  92% {
    transform: translateY(18px) scale(0.88);
  }
  96% {
    transform: translateY(14px) scale(0.91);
  }
  100% {
    transform: translateY(18px) scale(0.88);
  }
}

/* Card visuals */
.rg-card-photo {
  height: 58%;
  width: 100%;
  background-size: cover;
  background-position: center;
}
/* Real photography — warmth/saturation sits under subtle violet tint for brand cohesion */
.rg-photo-1 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 60%,
      rgba(0, 0, 0, 0.18) 100%
    ),
    url('~@/assets/images/nob-hill-cafe.webp');
}
.rg-photo-2 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 60%,
      rgba(0, 0, 0, 0.18) 100%
    ),
    url('https://images.unsplash.com/photo-1514933651103-005eec06c04b?w=500&q=80&auto=format&fit=crop');
}
.rg-photo-3 {
  background-image: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 60%,
      rgba(0, 0, 0, 0.18) 100%
    ),
    url('https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=500&q=80&auto=format&fit=crop');
}

.rg-card-info {
  padding: 9px 12px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.rg-card-name {
  font-family: 'AirbnbCereal_W_Bd', sans-serif;
  font-size: 13px;
  font-weight: 800;
  color: #1a1033;
  letter-spacing: -0.015em;
  line-height: 1.2;
}
.rg-card-sub {
  font-size: 9.5px;
  color: #64748b;
  font-weight: 500;
}
.rg-card-stars {
  font-size: 10px;
  color: #fdad00;
  letter-spacing: 1px;
  margin-top: 2px;
}
.rg-star-dim {
  color: #e5e7eb;
}

/* Direction overlays ---------------------------------------- */
.rg-ov {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  opacity: 0;
  pointer-events: none;
}
.rg-ov-badge {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  border: 4px solid white;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.22);
}
.rg-ov-label {
  font-family: 'AirbnbCereal_W_Bd', sans-serif;
  font-weight: 900;
  font-size: 16px;
  color: white;
  letter-spacing: 0.12em;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
}
.rg-ov-like-badge {
  background: #34c759;
}
.rg-ov-nope-badge {
  background: #ef4444;
}
.rg-ov-love-badge {
  background: #f4846c;
}

.rg-ov-like {
  background: rgba(52, 199, 89, 0.82);
  animation: rg-ov-like-fade 5.6s infinite ease-in-out;
}
.rg-ov-nope {
  background: rgba(239, 68, 68, 0.82);
  animation: rg-ov-nope-fade 5.6s infinite ease-in-out;
}
.rg-ov-love {
  background: rgba(244, 132, 108, 0.82);
  animation: rg-ov-love-fade 5.6s infinite ease-in-out;
}

@keyframes rg-ov-like-fade {
  0%,
  14% {
    opacity: 0;
  }
  22% {
    opacity: 1;
  }
  32% {
    opacity: 1;
  }
  34% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
@keyframes rg-ov-nope-fade {
  0%,
  46% {
    opacity: 0;
  }
  54% {
    opacity: 1;
  }
  64% {
    opacity: 1;
  }
  66% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
@keyframes rg-ov-love-fade {
  0%,
  78% {
    opacity: 0;
  }
  86% {
    opacity: 1;
  }
  94% {
    opacity: 1;
  }
  96% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

/* Floating +5 delta */
.rg-delta {
  position: absolute;
  left: 50%;
  top: 70%;
  transform: translateX(-50%);
  font-family: 'AirbnbCereal_W_Bd', sans-serif;
  font-size: 18px;
  font-weight: 900;
  color: #34c759;
  opacity: 0;
  text-shadow: 0 2px 8px rgba(52, 199, 89, 0.35);
  animation: rg-delta-float 5.6s infinite ease-out;
  pointer-events: none;
}
@keyframes rg-delta-float {
  0%,
  30% {
    opacity: 0;
    transform: translate(-50%, 0);
  }
  34% {
    opacity: 1;
    transform: translate(-50%, -10px);
  }
  42% {
    opacity: 0;
    transform: translate(-50%, -40px);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -40px);
  }
}

/* Legend */
.rg-legend {
  position: absolute;
  bottom: calc(30px + var(--iphone-home-indicator-reserve));
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-around;
  padding: 0 14px;
}
.rg-leg {
  font-size: 8px;
  font-weight: 700;
  color: #94a3b8;
  letter-spacing: 0.08em;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}
.rg-leg-arrow {
  font-size: 12px;
  color: #7c3aed;
  font-weight: 900;
}

@media (prefers-reduced-motion: reduce) {
  .rg-card-top,
  .rg-card-mid,
  .rg-card-back,
  .rg-ov-like,
  .rg-ov-nope,
  .rg-ov-love,
  .rg-delta {
    animation: none;
  }
  .rg-ov-like {
    opacity: 0.85;
  }
  /* Catch-all: the other 4 scenes (taste, booking, snap, happening)
     run 40+ infinite keyframes each — disable them all for anyone who
     has Reduce Motion enabled. */
  .iphone *,
  .iphone *::before,
  .iphone *::after {
    animation: none !important;
    transition: none !important;
  }
}
</style>
